/** What a highlighted square lets the selected piece do. */
export type HintKind = 'move' | 'capture' | 'pin' | 'raise' | 'lower';

export interface BoardHint {
  r: number;
  c: number;
  kind: HintKind;
}

export interface Square {
  r: number;
  c: number;
}

/** A summit to mark. `team` is the camp that owns it (two-summit mode); none for the shared one. */
export interface SummitMark {
  r: number;
  c: number;
  team?: 'I' | 'B';
}

/** The shared summit on e5. */
export const CENTER_SUMMIT: readonly SummitMark[] = [{ r: 4, c: 4 }];

/** Camera presets. */
export type CameraView = 'ivory' | 'basalt' | 'top';
